import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import type { PositionsDrawerRfqTab } from "#/store/app/positionsDrawer/positionsDrawerRfqTab";
import { usePositionsDrawerRfqTab } from "#/store/app/positionsDrawer/positionsDrawerRfqTab";
import { useRfqResponses as useGetRfqResponses } from "#/store/rfq/rfqResponses";
import { match } from "#/utils/match";

import { type RfqEntry } from "../../../Rfq.types";

const getTableData = (
  singleResponses: RFQResponseState[],
  multiResponses: RFQResponseState[],
  positionsDrawerRfqTab: PositionsDrawerRfqTab,
) => {
  const tableData: RfqEntry[] = [];
  if (singleResponses.length > 0) {
    tableData.push({
      variant: "single",
      count: singleResponses.length,
      instrument: `Single Leg (${singleResponses.length})`,
    });
  }
  if (multiResponses.length > 0 && positionsDrawerRfqTab !== "perps") {
    tableData.push({
      variant: "multi",
      count: multiResponses.length,
      instrument: `Multi Leg (${multiResponses.length})`,
    });
  }
  return tableData;
};

export const useRfqResponses = () => {
  const { market } = usePositionsDrawerMarket();
  const { positionsDrawerRfqTab } = usePositionsDrawerRfqTab();
  const {
    optionsResponses: {
      singleLeg: optionsSingleLeg,
      multiLeg: optionsMultiLeg,
    },
    perpsResponses: { singleLeg: perpsSingleLeg, multiLeg: perpsMultiLeg },
  } = useGetRfqResponses();

  const singleResponses = match([
    [optionsSingleLeg, positionsDrawerRfqTab === "options"],
    [optionsSingleLeg.concat(perpsSingleLeg), positionsDrawerRfqTab === "all"],
    [perpsSingleLeg, true],
  ]);
  const multiResponses = match([
    [optionsMultiLeg, positionsDrawerRfqTab === "options"],
    [optionsMultiLeg.concat(perpsMultiLeg), positionsDrawerRfqTab === "all"],
    [perpsMultiLeg, true],
  ]);

  const filteredSingleResponses = (singleResponses || []).filter((response) =>
    response.marketPairs.includes(market.pair),
  );
  const filteredMultiResponses = (multiResponses || []).filter((response) =>
    response.marketPairs.includes(market.pair),
  );

  return {
    singleResponses,
    multiResponses,
    filteredSingleResponses,
    filteredMultiResponses,
    tableData: getTableData(
      filteredSingleResponses,
      filteredMultiResponses,
      positionsDrawerRfqTab,
    ),
  };
};
